module.exports = __webpack_public_path__ + "media/images/webpage/hotels/93/plan4-3-053e0b6e4ae1eefb72686f5e7323ca9c.webp";